import React from 'react';
import { Skeleton } from '@mui/material';
import { FullWrapper, Wrapper } from 'components';

export const SkeletonDetailUser = () => (
  <Wrapper>
    <Skeleton
            height={130}
            style={{ margin: '1rem auto' }}
            variant="circular"
            width={130}
        />
    <Skeleton
            height={40}
            style={{ margin: '2rem auto' }}
            width={200}
        />
    <Skeleton
            height={200}
            style={{ marginBottom: '2rem' }}
            variant="rectangular"
        />
    <Skeleton
            height={100}
            style={{ marginBottom: '2rem' }}
            variant="rectangular"
        />
    <Skeleton
            height={150}
            variant="rectangular"
        />
  </Wrapper>
);

export const SkeletonAppUser = () => (
  <FullWrapper>
    <Skeleton
            height={200}
            style={{ marginBottom: '2rem' }}
            variant="rectangular"
        />
  </FullWrapper>
);
